/* TypeScript file generated from Footer.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as FooterJS from './Footer.re.mjs';

export type props = {};

export const make: React.ComponentType<{}> = FooterJS.make as any;

export const $$default: React.ComponentType<{}> = FooterJS.default as any;

export default $$default;
